/**
 * package: com.inq.ui
 * class: SkinLoader
 * @extends com.inq.ui.Container
 * @constructor
 * @param {Application=} app - the Application instance - this is the parent of the SkinLoader instance
 */
com.inq.ui.SkinLoader = function(app) {
	com.inq.events.EventDispatcher.call(this);
	this.application = app || Application.application;
	com.inq.ui.SkinLoader.init();
};
$hxClasses.extend(com.inq.events.EventDispatcher, com.inq.ui.SkinLoader, "com.inq.ui.SkinLoader");

/**
 * In initialization of application need to setup the default value of public properties.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.ui.SkinLoader.init = function() {
	/** @type {boolean} */
	com.inq.ui.SkinLoader.hasClientBody = null;
	/** @type {boolean} */
	com.inq.ui.SkinLoader.skinInClient = null;
};

/**
 * _getSkinPath
 *
 * private static function _getSkinPath():String
 * @private
 * @static
 * @return {string}
 */
com.inq.ui.SkinLoader._getSkinPath = function () {
    if (com.inq.flash.client.control.FlashPeer.getIsSkinLocal() ) {
        return com.inq.ui.SkinLoader._skinpath = com.inq.flash.client.control.FlashPeer.getSkinPath()
    }
    else {
        return com.inq.ui.SkinLoader._skinpath = com.inq.flash.client.control.FlashPeer.getImagePath()
    }

};


/**
 * getSkinBase
 *
 * $type TFun([],TInst(String,[]))
 * public static function getSkinBase():String
 * @public
 * @static
 * @return {string}
 */
com.inq.ui.SkinLoader.getSkinBase = function() {
	/** @type {string} */
	var skin = com.inq.flash.client.control.FlashPeer.getSkin()
	/** @type {Array} */
	var aPath = skin.split("\\").join("/").split("/");
	aPath.pop();
	return aPath.join("/");
};


/**
 * getSkinPath
 *
 * public static function getSkinPath()
 * @public
 * @static
 * @return {string}
 */
com.inq.ui.SkinLoader.getSkinPath = function() {
	return com.inq.ui.SkinLoader._skinpath;
};

/**
 * Returns the URL of current active (drawn) skin.
 * @return {string}
 */
com.inq.ui.SkinLoader.getSkinURL = function() {
	return com.inq.ui.SkinLoader.currentSkin.path;
};

/**
 * prepareSkinPath
 * @param {string} skinPath
 * @return {string}
 */
com.inq.ui.SkinLoader.prepareSkinPath = function(skinPath) {
	if (HxOverrides.substr(skinPath, 0, 2) == "./") {
		skinPath = HxOverrides.substr(skinPath, 2, null);
	}
	if (skinPath.indexOf("\\") < 0 && skinPath.indexOf("/") < 0) {
		skinPath = com.inq.ui.SkinLoader.getSkinBase() + "/" + skinPath;
	}
	return skinPath;
};
/**
 * PreloadNewSkin
 *
 * public static function PreloadNewSkin(nameNextSkin:String):Void
 * @public
 * @static
 * @param {string}  nameNextSkin
 * @return {void}
 */
com.inq.ui.SkinLoader.PreloadNewSkin = function(nameNextSkin) {
	/** @type {string} */
	var skinPath = com.inq.ui.SkinLoader.prepareSkinPath(nameNextSkin);
	if (!com.inq.ui.SkinLoader.skinCollection[skinPath]) {
		com.inq.flash.client.control.FlashPeer.prefetchURL(skinPath);
	}
};


/**
 * LoadNewSkin
 *
 * public static function LoadNewSkin(nameNextSkin:String):Void
 * @public
 * @static
 * @param {string}  nameNextSkin
 * @return {void}
 */
com.inq.ui.SkinLoader.LoadNewSkin = function(nameNextSkin) {
	/** @type {com.inq.ui.SkinLoader} */
	var sl = new com.inq.ui.SkinLoader();

	/* get the attributes from the current controls */
	/** @type {com.inq.ui.TextInput} */
	var ti = Application.application.getTextInput("txtInput");
	/** @type {com.inq.ui.Button} */
	var cPB = Application.application.getButton("ClickPersistent");
	/** @type {com.inq.ui.Button} */
	var bPO = Application.application.getButton("btnPopOut");
	/** @type {com.inq.ui.Button} */
	var bCa = Application.application.getButton("btnCall");
	/** @type {com.inq.ui.Button} */
	var bCC = Application.application.getButton("btnCloseChat");

	com.inq.ui.SkinLoader.contextArray[0] = nameNextSkin;
	com.inq.ui.SkinLoader.contextArray[1] = com.inq.flash.client.chatskins.SkinControl.cw.exportData();
	com.inq.ui.SkinLoader.contextArray[2] = ti._getInput();
	com.inq.ui.SkinLoader.contextArray[3] = cPB.getVisible();/* is the 'Click to Persistent" button visible */
	com.inq.ui.SkinLoader.contextArray[4] = null != bPO?bPO.getVisible():false;
	com.inq.ui.SkinLoader.contextArray[5] = null != bCa?bCa.getVisible():false;
	com.inq.ui.SkinLoader.contextArray[6] = null != bCC?bCC.getVisible():false;

	// Reset the SndMgr initialization flag to re-initialize the button mute
	com.inq.flash.client.chatskins.SndMgr.lazyInitDone = false;
	// Save previous customer text
	com.inq.flash.client.chatskins.SkinControl.customerTypedText = ti._text.value;

	sl.addEventListener(com.inq.events.Event.COMPLETE,com.inq.ui.SkinLoader.successNewSkinLoad);
	sl.drawSkin(nameNextSkin);
};


/**
 * successNewSkinLoad
 *
 * $type TFun([{ name => event, t => TInst(com.inq.events.Event,[]), opt => false }],TEnum(Void,[]))
 * private static  function successNewSkinLoad(event:Event):Void
 * @private
 * @static
 * @param {com.inq.events.Event}  event
 * @return {void}
 */
com.inq.ui.SkinLoader.successNewSkinLoad = function(event) {
	haxe.Log.trace("success",{ fileName : "SkinLoader.hx", lineNumber : 877, className : "com.inq.ui.SkinLoader", methodName : "successNewSkinLoad"});
    com.inq.ui.SkinLoader.newSkinLoaded = true;
	com.inq.flash.client.chatskins.SkinControl.cw = new com.inq.flash.client.chatskins.ChatTextArea(Application.application.chatWindow);
	Application.application.resize();/* resize the skin to the container size */

	if (com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat()) {
		if(com.inq.utils.Util.isIE) {
			Application.ResizeStage(window.parent.document.documentElement.clientWidth,
									window.parent.document.documentElement.clientHeight);
		} else {
			Application.ResizeStage(window.top.innerWidth,
									window.top.innerHeight);
		}
	}
	/**
	 * @see http://jira.touchcommerce.com/browse/RTDEV-10951
	 * @description calling setfocus on inputfield before moveChat cause old chat area used while rendering
	 */
	if(!com.inq.utils.Capabilities.isIpad())
		com.inq.flash.client.chatskins.SkinControl.setFocusOnInputField();
	com.inq.flash.client.chatskins.SkinControl.setupButtons();
	com.inq.flash.client.chatskins.SkinControl.startKeyListener();
	com.inq.flash.client.chatskins.SkinControl.startEmailKeyListener();
	com.inq.flash.client.chatskins.SkinControl.setUpFocusAndSelection();

	/** @type {com.inq.ui.Button} */
	var bPO = Application.application.getButton("btnPopOut");
	/** @type {com.inq.ui.Button} */
	var bCa = Application.application.getButton("btnCall");
	/** @type {com.inq.ui.Button} */
	var bCC = Application.application.getButton("btnCloseChat");

	/* Set the skin name in the cookie */
	if (com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
		com.inq.flash.client.control.PersistenceManager.SetValue(EMBEDDED_SKIN_PATH, com.inq.ui.SkinLoader.contextArray[0]);
	} else {
        com.inq.flash.client.control.PersistenceManager.SetValue(SKIN_PATH, com.inq.ui.SkinLoader.contextArray[0]);
	}
	/* restore the attributes from the controls */
	com.inq.flash.client.chatskins.SkinControl.cw.importData(com.inq.ui.SkinLoader.contextArray[1]);
	com.inq.flash.client.chatskins.SkinControl.showPersistentChatButtons(com.inq.ui.SkinLoader.contextArray[3]);
	if(null != bPO) bPO.setVisible(com.inq.ui.SkinLoader.contextArray[4]);
	if(null != bCa) bCa.setVisible(com.inq.ui.SkinLoader.contextArray[5]);
	if(null != bCC) bCC.setVisible(com.inq.ui.SkinLoader.contextArray[6]);
	com.inq.flash.client.chatskins.SkinControl.ClassInits();

	var ti = com.inq.flash.client.chatskins.SkinControl.getTextInputField();
	if (!!ti) {
		var msgCount = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT, 0);
		var typedText = com.inq.flash.client.chatskins.SkinControl.customerTypedText;
		if (typedText.length > 0) {
			ti.setText(typedText);
		}
		if (msgCount == 0) {
			ti.setIntroduction();
		}
	}
};


/**
 * getSkinPath
 *
 * private function getSkinPath()
 * @private
 * @this com.inq.ui.SkinLoader
 * @return {string}
 *
 * TODO: it seems that this method never used
 */
com.inq.ui.SkinLoader.prototype.getSkinPath = com.inq.ui.SkinLoader.getSkinPath;

/**
 * testClientBody
 * TestClientBody - private
 * Look in the XML for "mx:ClientBody"
 * If it exists then return true
 *
 * $type TFun([{ name => xmlNode, t => TInst(Xml,[]), opt => false }],TEnum(Bool,[]))
 * private function testClientBody(xmlNode:Xml):Bool
 * @private
 * @this com.inq.ui.SkinLoader
 * @param {Xml}  xmlNode
 * @return {boolean}
 */
com.inq.ui.SkinLoader.prototype.testClientBody = function(xmlNode) {
	/** @type {haxe.xml.Fast} */
	var fast = new haxe.xml.Fast(xmlNode.firstElement());
	/** @type {haxe.xml.Fast} */
	var clientNode;
	try {
		clientNode = fast.node.resolve("mx:ClientBody");
	} catch( e ) {
		clientNode = null;
	}
	return clientNode != null;
};


/**
 * testSkinInClient - tests to see if this skin is designed to be in the client space
 * Please note, we do not offer a skin in a client unless we are mobile and NOT persistent
 * For testing on the PC, the tester can use safari and choose in the menu:
 * Develop->User Agent->Safari iOS 4.3.3 -- iPad
 *
 * $type TFun([{ name => xmlNode, t => TInst(Xml,[]), opt => false }],TEnum(Bool,[]))
 * public function testSkinInClient(xmlNode:Xml):Bool
 * @public
 * @this com.inq.ui.SkinLoader
 * @param {Xml}  xmlNode
 * @return {boolean} - true/false
 */
com.inq.ui.SkinLoader.prototype.testSkinInClient = function(xmlNode) {
	/** @type {haxe.xml.Fast} */
	var fast = new haxe.xml.Fast(xmlNode.firstElement());
	/** @type {haxe.xml.Fast} */
	var clientNode;
	/* Check for Mobile, if not Mobile, then assume no skin in client
	 * Also, if persistent, assume no skin in client*/
	/** @type {boolean} */
	var _isPersistent = com.inq.flash.client.control.FlashPeer.isPersistentWindow();
	/** @type {boolean} */
	var isDivChat = com.inq.utils.Util.getConfig("divSkin", false);

	if((com.inq.utils.Capabilities.isMobile() || isDivChat ) && !_isPersistent) {
		try {
			clientNode = fast.node.resolve("mx:ClientBody");
		} catch( e ) {
			clientNode = null;
		}
		if(clientNode != null) {
			var $it0 = clientNode.getElements();
			while( $it0.hasNext() ) {
				/** @type {haxe.xml.Fast} */
				var childNode1 = $it0.next();
				if(childNode1.has.resolve("id") && childNode1.att.resolve("id") == "Skin") return true;
				if(childNode1.has.resolve("id") && childNode1.att.resolve("id") == "inqTitleBar") {
					var $it1 = childNode1.getElements();
					while( $it1.hasNext() ) {
						/** @type {haxe.xml.Fast} */
						var subNode1 = $it1.next();
						if(subNode1.has.resolve("id") && subNode1.att.resolve("id") == "Skin") return true;;
					}
				}
			}
		}
	}
	return false;
};

/**
 * loadSkinConfig - tests to see if the skin configuration map is loaded, if not, it finds it in the XML and loads it
 *
 * @public
 * @this com.inq.ui.SkinLoader
 * @param {Xml}  xmlNode
 * @return {void}
 */
com.inq.ui.SkinLoader.prototype.loadSkinConfig = function(xmlNode) {
	/** @type {haxe.xml.Fast} */
	var fast = new haxe.xml.Fast(xmlNode.firstElement());
	/** @type {haxe.xml.Fast} */
	var scriptNode;
	try {
		scriptNode = fast.node.resolve("mx:Script");
		if (!scriptNode) return;
	} catch( e ) {
		return;
	}
	this._processMxmlScript(scriptNode.getInnerData());
};

/**
 * _processMxmlScript - process the Script tag in the MXML if it contains the "skinConfig" JSON.
 *
 * private function _renderMxml(it:Iterator < Xml > , parentObject:Container)
 * @private
 * @this com.inq.ui.SkinLoader
 * @param {String}  source
 * @return {void}
 */
com.inq.ui.SkinLoader.prototype._processMxmlScript = function (source) {
	// If we have the skinConfig map, then don't reparse and return
	if (Application.application["skinConfig"]) {
		return;
	}

	var indx = source.indexOf("skinConfig");

	if (indx > 0) {
		// find start of the JSON
		indx = source.indexOf("{", indx);
		/** @type {number} */
		var indxEnd = source.lastIndexOf("}");
		/** @type {string} */
		var config = HxOverrides.substr(source, indx, indxEnd + 1 - indx);

		// remove new lines and extra spaces
		var jsonConfig = config.replace(/\r?\n\s+|\r/g, "");
		// replace ' to ", because it will cause error during JSON parse
		jsonConfig = jsonConfig.replaceAll("'", "\"");
		// remove spaces before properties if they left after first replace
		jsonConfig = jsonConfig.replace(/(,)(\s+)(\S+:)/g, "$1$3");

		Application.application["skinConfig"] = com.inq.flash.client.control.FlashPeer.JSONParse(jsonConfig, true);

		if (Application.application["skinConfig"] === null) {
			com.inq.flash.client.control.FlashPeer.evaluateLegacySettings(
				"Application.application['skinConfig'] = " + config
			);
		}
		// Fire skinConfig Mxml event handlers after init
		com.inq.flash.client.chatskins.SkinControl.fireMxmlHandler("onParsedFlashVars");
	}
};

/**
 * _renderMxml
 *
 * $type TFun([{ name => it, t => TType(Iterator,[TInst(Xml,[])]), opt => false },{ name => parentObject, t => TInst(com.inq.ui.Container,[]), opt => false }],TEnum(Void,[]))
 * private function _renderMxml(it:Iterator < Xml > , parentObject:Container)
 * @private
 * @this com.inq.ui.SkinLoader
 * @param {Object}  it
 * @param {com.inq.ui.Container}  parentObject
 * @return {void}
 */
com.inq.ui.SkinLoader.prototype._renderMxml = function(it,parentObject) {
	/** @type {string} */
	var name;
	/** @type {?string} */
	var id;
	/** @type {Xml} */
	var xmlNode;
	/** @type {?string} */
	var source;
	/** @type {Object} */
	var newit;
	/** @type {com.inq.ui.Canvas} */
	var canvas;
	/** @type {?string} */
	var innerHTML;
	/** @type {boolean} */
	var isIEQuirks = (com.inq.utils.Util.isIE && window.top.document.compatMode !== 'CSS1Compat');

	while (it.hasNext()) {
		var el = it.next();
		name = el.getNodeName();
		id = el.get("id");
		if (id == null) id = "tcChat_" + Math.round(Math.random() * Math.PI * 7654321);

		if (name.indexOf("html:") == 0) {
			xmlNode = el;
			/** @type {com.inq.ui.Html} */
			var uiHtmlObj = new com.inq.ui.Html(name, id, parentObject);

			/**
			 * @see http://jira.touchcommerce.com/browse/RTDEV-8130
			 * This has to be set before other aria attributes are set. so adding this if condition before the applyAttributes statement.
			 * This is need to fix android voice over read issue on dynamically changed text
			 */
			/**
			 * @see http://jira.touchcommerce.com/browse/RTDEV-15623
			 * While trying to track down what recent changes caused problem for this ticket, I found out the problem
			 * was caused by the following if statement.  Not sure why because this statement has not been modified
			 * recently.
			 */
			/*
			 if( (id === "tc-aria-readme" || id === "tc-aria-readme-mini" ) && com.inq.utils.Capabilities.isAndroid()) {
			 uiHtmlObj._div.setAttribute("aria-label", "  ");
			 }
			 */

			this.applyAttributes(xmlNode, uiHtmlObj);
			uiHtmlObj.attachTo(parentObject);
			/* OK, if we are the dragbar or the corner, we are a special case
			 * We will not register these
			 */
			if (id != "inqTitleBar" && id != "inqDivResizeCorner" && id != "tcChat_Skin")
				Application.application.setMxmlItem(uiHtmlObj);
			else haxe.Log.trace("special case: " + id, {
				fileName: "SkinLoader.hx",
				lineNumber: 408,
				className: "com.inq.ui.SkinLoader",
				methodName: "_renderMxml"
			});

			newit = xmlNode.elements();
			if (!newit.hasNext() && xmlNode.firstChild() != null) {
				innerHTML = xmlNode.firstChild().getNodeValue();
				if (innerHTML != null && innerHTML != "") uiHtmlObj._div.innerHTML = innerHTML;
			}
			this._renderMxml(newit, uiHtmlObj);
			if (id != "inqTitleBar" && id != "inqDivResizeCorner") uiHtmlObj.applyStyles();
			// IE Quirks mode does not support proper "position=fixed" handling, best option is to fallback to absolute
			if (id == "Minimized" && com.inq.utils.Util.isIE && isIEQuirks && uiHtmlObj._div.style.position == "fixed") {
				uiHtmlObj._div.style.position = "absolute";
			}
		} else
		switch(name) {
			case "mx:Style":
				xmlNode = el;
				source = xmlNode.get("source");
				if (source != null) {
					if (com.inq.flash.client.control.FlashPeer.getIsSkinLocal()) {
						source = source + "?" + Math.random().toString();
						source = com.inq.flash.client.control.FlashPeer.getSkinPath()+ "/" + source
				    }
					else if (com.inq.flash.client.control.FlashPeer.noJSHostingInTagserver()) {
						source = com.inq.flash.client.control.FlashPeer.getClientStaticURL() + "/" + source;
					}
				    else
					{
				        source = com.inq.ui.SkinLoader.getSkinPath() + "/" + source
				    }
				    /*  attach this to head */
					/* If the parent of Style is ClientBody, then we want to put into head of the client document */
					/** @type {Document} */
					var doc = window.document;
					try {
						doc = "mx:ClientBody" == xmlNode.getParent().getNodeName()?window.parent.document:window.document;
					} catch( e ) {
						doc = window.document;
					}

					/** @type {HTMLCollection} */
					var heads = com.inq.ui.Container._getElementByTN("HEAD",doc);
					/** @type {HTMLElement} */
					var head = heads[0];

					/** @type {HTMLElement} */
					var node = null;
					/** @type {HTMLCollection} */
					var nodes = head.getElementsByTagName("LINK");
					if(nodes != null && nodes.length > 0) {
						for (var i = 0, len = nodes.length; i < len; i++) {
							if (nodes[i].id == "mxStyle") {
								node = nodes[i];
								break;
							}
						}
					}


					if(node == null) {
						node = doc.createElement("LINK");
						node.name = "mxStyle";
						node.type = "text/css";
						node.rel = "stylesheet";
						node.media = "screen";
						if (window.top.location.protocol == "https:") {
						    if (source.indexOf("https") == -1) {
						        source = source.replace("http", "https")
						    }
						}
						node.href = source;
						head.appendChild(node);
					} else {
						node.href = source;
					}
					Application.application.styleLinksList.push(node);
				}
				break;
			case "mx:ClientBody":
				xmlNode = el;
				/** @type {com.inq.ui.ClientBody} */
				var clientBody = new com.inq.ui.ClientBody();
				Application.application.setMxmlItem(clientBody);
				newit = xmlNode.elements();
				this._renderMxml(newit,clientBody);
				break;
		    case "mx:Literal":
			    xmlNode = el;
		        var literal = new com.inq.ui.Literal(id);
		        this.applyAttributes(xmlNode, literal);
		        literal.attachTo(parentObject);
		        Application.application.setMxmlItem(literal);
			    newit = xmlNode.elements();
		        this._renderMxml(newit, literal);
		        break;
		    case "mx:htag":
		        xmlNode = el;
		        var htmlTagName = xmlNode.get("el");
		        var uiHtml = new com.inq.ui.Html(htmlTagName, id, parentObject);
		        this.applyAttributes(xmlNode, uiHtml);
			    uiHtml.attachTo(parentObject);
		        Application.application.setMxmlItem(uiHtml);
			    newit = xmlNode.elements();
		        if (!newit.hasNext() && xmlNode.firstChild() != null) {
		            innerHTML = xmlNode.firstChild().getNodeValue();
		            if (innerHTML != null && innerHTML != "") {
			            uiHtml._div.innerHTML = innerHTML
		            }
		        }
		        this._renderMxml(newit, uiHtml);
			    uiHtml.applyStyles();
		        break;
			case "mx:Canvas":
				xmlNode = el;
				canvas = new com.inq.ui.Canvas(id);
				canvas.attachTo(parentObject);
				this.applyAttributes(xmlNode,canvas);
				canvas.applySkinAttribute();
				Application.application.setMxmlItem(canvas);
				newit = xmlNode.elements();
				this._renderMxml(newit,canvas);
				break;
			case "mx:Button":
				xmlNode = el;
				var sources = [];

				var $it0 = xmlNode.elementsNamed("mx:upSkin");
				while ($it0.hasNext()) {
					var itm = $it0.next();
					source = this.unembed("" + Std.string(itm.firstChild()), btn);
					sources.push(source);
				}

				var text = xmlNode.get("text");
				var btn = new com.inq.ui.Button(id, sources, text);
				btn.attachTo(parentObject);
				this.applyAttributes(xmlNode, btn);

				btn.addEventListener(com.inq.events.MouseEvent.CLICK, null);
				Application.application.setMxmlItem(btn);
				break;
			case "mx:Text":
				xmlNode = el;
				/** @type {com.inq.ui.Text} */
				var txt = new com.inq.ui.Text();
				this.applyAttributes(xmlNode,txt);
				txt.attachTo(parentObject);
				Application.application.setMxmlItem(txt);
				break;
			case "mx:Image":
				xmlNode = el;
				/** @type {com.inq.ui.Image} */
				var img = new com.inq.ui.Image(id);
				this.applyAttributes(xmlNode,img);

				var $it1 = xmlNode.elementsNamed("mx:source");
				while ($it1.hasNext()) {
					/** @type {Xml} */
					var item = $it1.next();
					source = this.unembed("" + Std.string(item.firstChild()), img);
					img.setSrc(source);
				}
				/* trace("source=" + source) ; */

				img.attachTo(parentObject);
				Application.application.setMxmlItem(img);
				break;
			case "mx:TextArea":
				xmlNode = el;
				/** @type {com.inq.ui.TextArea} */
				var ta = new com.inq.ui.TextArea(id);
				this.applyAttributes(xmlNode, ta);
				ta.attachTo(parentObject);
				Application.application.setMxmlItem(ta);
				break;
			case "mx:TextInput":
				xmlNode = el;
				/** @type {com.inq.ui.TextInput} */
				var textInput = new com.inq.ui.TextInput(id);
				this.applyAttributes(xmlNode, textInput);
				textInput.attachTo(parentObject);
				Application.application.setMxmlItem(textInput);
				break;
			case "mx:LineInput":
				xmlNode = el;
				/** @type {com.inq.ui.LineInput} */
				var lineInput = new com.inq.ui.LineInput(id);
				this.applyAttributes(xmlNode, lineInput);
				lineInput.attachTo(parentObject);
				Application.application.setMxmlItem(lineInput);
				break;
			case "mx:Label":
				xmlNode = el;
				/** @type {com.inq.ui.Label} */
				var label = new com.inq.ui.Label();
				this.applyAttributes(xmlNode, label);
				label.attachTo(parentObject);
				Application.application.setMxmlItem(label);
				break;
			case "mx:XFrame":
				xmlNode = el;
				/** @type {com.inq.ui.XFrame} */
				var xframe = new com.inq.ui.XFrame(id);
				var siteConstants = com.inq.flash.client.control.FlashPeer.getSiteConstants();
				var source = xmlNode.get("source");
                /*Native support for loading ACIF v3: If ACIF_V2_XFORMS_ID is defined in the business rule as a String Constant,
                then get the source from the Xframe element of skin and compare it with ACIF_V2_XFORMS_ID*/
				if(siteConstants && siteConstants.ACIF_V2_XFORMS_ID && source){
					var urldata = com.inq.flash.client.control.FlashPeer.parseXFrameUrl(this.unembed(source,null));
					if(siteConstants.ACIF_V2_XFORMS_ID == urldata.params[com.inq.flash.client.data.MessageFields.DATA_DTID]){
                        //if they are equal, then set the init to false so that loading of elements does not happen through the legacy code but through ACIF V3
						xmlNode.set("init", "false");
						xframe.setAttribute("data-acif-v2-frame","");
					}
				}
				this.applyAttributes(xmlNode, xframe);
				xframe.attachTo(parentObject);
				Application.application.setMxmlItem(xframe);
				break;
			case "mx:IFrame":
				xmlNode = el;
				/** @type {com.inq.ui.IFrame} */
				var iframe = new com.inq.ui.IFrame(id);
				this.applyAttributes(xmlNode, iframe);
				iframe.attachTo(parentObject);
				Application.application.setMxmlItem(iframe);
				break;
			case "mx:Script":
				source = el.toString();
				this._processMxmlScript(source);
				break;
			case "mx:FileInput":
				xmlNode = el;
				/** @type {com.inq.ui.FileInput} */
				var fi = new com.inq.ui.FileInput(id);
				this.applyAttributes(xmlNode,fi);
				fi.attachTo(parentObject);
				Application.application.setMxmlItem(fi);
				break;
			case "mx:VideoTag":
				xmlNode = el;
				var vi = new com.inq.ui.VideoTag(id);
				this.applyAttributes(xmlNode, vi);
				vi.attachTo(parentObject);
				Application.application.setMxmlItem(vi);
				break;
			case "mx:VideoPlayer":
				var vp = new com.inq.ui.VideoPlayer(id);
				this.applyAttributes(el, vp);
				vp.attachTo(parentObject);
				Application.application.setMxmlItem(vp);
				break;
		}
	}
};

/**
 * _draw
 * Important: Method calls loadSkinConfig.
 *
 * $type TFun([{ name => mxml, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * private function _draw(mxml:String)
 * @private
 * @this com.inq.ui.SkinLoader
 * @param {string}  mxml
 * @return {void}
 */
com.inq.ui.SkinLoader.prototype._draw = function(mxml) {
	/** @type {Xml} */
	var xml;

	/** @type {com.inq.ui.Container} */
	var me = new com.inq.ui.Container("Skin");
	me.clear();
	
	if (mxml == null) {
		mxml = haxe.Resource.getString("mxml");
	}
	
	var format = com.inq.flash.client.control.FlashPeer.getChatSkinFmt();
	try {
		if (format === "json") {
			//For content type of "application/json", 
			//return result is parsed to JSON array already in LoadMgr.handleSuccess...
			//But let's check and parse it in case.
			if (typeof mxml === "string") {
				mxml = Inq.JSON.parse(mxml);
			}
			xml = com.inq.utils.JsonML.jsonToXml(mxml);
		}
		else {
			xml = Xml.parse(mxml);
		}
	} catch( e ) {
		haxe.Log.trace("Parsing mxml ERROR:" + Std.string(e),{ fileName : "SkinLoader.hx", lineNumber : 733, className : "com.inq.ui.SkinLoader", methodName : "_draw"});
		return;
	}

	
	haxe.Log.trace("Ask if skin is in client",{ fileName : "SkinLoader.hx", lineNumber : 304, className : "com.inq.ui.SkinLoader", methodName : "_draw"});

	this.loadSkinConfig(xml);

	com.inq.ui.SkinLoader.hasClientBody = this.testClientBody(xml);
	com.inq.ui.SkinLoader.skinInClient = this.testSkinInClient(xml);
	if(com.inq.ui.SkinLoader.skinInClient) {
		haxe.Log.trace("skin is in the client",{ fileName : "SkinLoader.hx", lineNumber : 308, className : "com.inq.ui.SkinLoader", methodName : "_draw"});
		/* move application div to the client space */
		/** @type {HTMLElement} */
		var div = Application.application._div;
		/** @type {Document} */
		var doc = window.parent.document;
		/** @type {HTMLElement} */
		var loc = window.frameElement;
		Application.application.setPanelWindow(window.parent);

		if (div.ownerDocument == doc) {
			haxe.Log.trace("We already are in the client space, no need to move",{ fileName : "SkinLoader.js", lineNumber : 865, className : "com.inq.ui.SkinLoader", methodName : "_draw"});
		} else {
			Application.application.clear();
			haxe.Log.trace("remove element",{ fileName : "SkinLoader.hx", lineNumber : 317, className : "com.inq.ui.SkinLoader", methodName : "_draw"});
			if (div.parentElement) {
				div.parentElement.removeChild(div);
			}

			try {
				if(doc.adoptNode) {
					haxe.Log.trace("Adopt the node into the new document",{ fileName : "SkinLoader.hx", lineNumber : 329, className : "com.inq.ui.SkinLoader", methodName : "_draw"});
					doc.adoptNode(div);
					haxe.Log.trace("Node has been adopted into new document",{ fileName : "SkinLoader.hx", lineNumber : 331, className : "com.inq.ui.SkinLoader", methodName : "_draw"});
				} else {
					haxe.Log.trace("adoptNode not implemented on this browser create new div",{ fileName : "SkinLoader.hx", lineNumber : 333, className : "com.inq.ui.SkinLoader", methodName : "_draw"});
					div = doc.createElement("DIV");
				}
			} catch( e ) {
				haxe.Log.trace("Document could not adopt element",{ fileName : "SkinLoader.hx", lineNumber : 337, className : "com.inq.ui.SkinLoader", methodName : "_draw", customParams : [e]});
			}
		}

		div.name = "Stage";

		haxe.Log.trace("insert element as next sibling",{ fileName : "SkinLoader.hx", lineNumber : 346, className : "com.inq.ui.SkinLoader", methodName : "_draw"});

		if (com.inq.flash.client.control.FlashPeer.noV3FrameChat()) {
			div.style.zIndex = "999999";
			var tb = com.inq.ui.Container._getElementById("inqTitleBar",doc);
			tb.parentElement.insertBefore(div, tb);
		}
		else {
			div.style.zIndex = loc.style.zIndex;
			if (com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
				var embeddedDiv = com.inq.ui.Container._getElementById(com.inq.flash.client.control.FlashPeer.getEmbeddedTheme().id,doc);
				embeddedDiv.innerHTML = "";
				embeddedDiv.appendChild(div);
			}
			else {
				loc.parentElement.insertBefore(div, loc.nextSibling);
			}
		}
		Application.application._div = div;
		haxe.Log.trace("skin has been moved to the client",{ fileName : "SkinLoader.hx", lineNumber : 349, className : "com.inq.ui.SkinLoader", methodName : "_draw"});
	}

	/* 	untyped Lib.document.body.cssText = "overflow: ignore" ; */
	/* applyAttributes(xml, me) ; */
	Application.application.initStyle("id","Skin");
	Application.application.clear();
	Application.application.setID("Skin");

	this.applyAttributes(xml.firstElement(),Application.application);
	/* 	application.width = "400"; */
	/* 	application.height = "240" ; */

	/* Are we in an IFrame or in our own window????
	 * IF 		window.frameElement exists THEN we are in an IFRAME
	 * ELSE IF	window.opener exists and the window.name = inqPopOut THEN we are a pop-out window
	 *
	 * If the application is in a pop-out window:
	 * THEN attach to stage
	 * ELSE attach to body
	 */
	if (window.frameElement) {
		Application.application.attachToElement(window.document.body);
	}

	/** @type {Object} */
	var it = xml.elements();
	while (it.hasNext()) {
		var x = it.next();
		this._renderMxml(x.elements(), Application.application);
	}

	this.executeCode();
};

/**
 * applyAttributes
 *
 * $type TFun([{ name => xmlNode, t => TInst(Xml,[]), opt => false },{ name => c, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function applyAttributes (xmlNode:Xml, c:Dynamic)
 * @private
 * @this com.inq.ui.SkinLoader
 * @param {Xml}  xmlNode
 * @param {*}  container
 * @return {void}
 */
com.inq.ui.SkinLoader.prototype.applyAttributes = function(xmlNode, container) {
	var $it0 = xmlNode.attributes();
	while( $it0.hasNext() ) {
		var ats = $it0.next();
		/** @type {string} */
		var attName = ats;
		/** @type {string} */
		var attValu = xmlNode.get(attName);

		var attributeTypeList = ["role", "alt", "tabindex", "accesskey", "tooltip", "required",
			"data-state-label-list"
		];
		if ( StringTools.startsWith(attName.toLowerCase(), 'aria-') || attributeTypeList.includes(attName.toLowerCase())) {
			/* Get Attribute separately here */
			container.initAttribute(attName.toLowerCase(), attValu);
		} else {
			/* Continue with style */
			switch (attName) {
				case "id":
					container.setID(attValu);
					break;
				case "el":
					container._div = document.createElement(attValu);
					break;
				case "min-width":
					container.initStyle(attName, attValu + "px");
					break;
				case "style":
					if (js.Boot.__instanceof(container, com.inq.ui.Html)) {
						// container {com.inq.ui.Html}
						container._setStyle(attValu);
					}
					break;
				case "scrolling":
					container.setScrolling(attValu);
					break;
				case "source":
					container.setSrc(this.unembed(attValu, container));
					break;
				case "backgroundImage":
					container.initStyle("backgroundImage", this.unembed(attValu, container));
					container.setBackgroundImage(this.unembed(attValu, container), false);
					break;
				case "enabled":
					container.setEnabled(attValu == "false" ? false : true);
					break;
				case "visible":
					if (attValu == "collapse") {
						container.initStyle("visibility", "collapse");
						attValu = "false";
					}
					container.initStyle("visible", attValu);
					container.setVisible(attValu == "false" ? false : true);
					break;
				case "upSkin":
					// container {com.inq.ui.Button}
					container.initStyle("upSkin", this.unembed(attValu, container));
					container.setUpSkin(this.unembed(attValu, container));
					break;
				case "overSkin":
					container.initStyle("overSkin", this.unembed(attValu, container));
					break;
				case "init":
					// container {com.inq.ui.XFrame}
					container.setInitOnLoad(attValu);
					break;
				case "htmlLabel":
					if (typeof attValu != "undefined") {
						container.addHtmlLabel(attValu);
					}
					break;
				case "placeholder":
					container.setIntroduction(attValu);
					break;
				case "label":
					container.setLabel(attValu);
					break;
				default:
					container.initStyle(attName, attValu);
			}
		}
	}
	container.applyStyle();
	container.applyAttributeMap();
};


/**
 * unembed
 *
 * $type TFun([{ name => source, t => TInst(String,[]), opt => false },{ name => con, t => TInst(com.inq.ui.Container,[]), opt => true }],TInst(String,[]))
 * private function unembed(source:String, ?con:Container):String
 * @private
 * @this com.inq.ui.SkinLoader
 * @param {string}  source
 * @param {com.inq.ui.Container}  con
 * @return {string}
 */
com.inq.ui.SkinLoader.prototype.unembed = function(source,con) {
	/** @type {boolean} */
	var bEmbeded = false;
	/** @type {string} */
	var s = source;
	/** @type {EReg} */
	var embedRegexp = new EReg("@Embed\\('([^']*)',([^,]*),([^,]*),([^,]*),([^,]*)\\)","i");
	try {

		/* "@Embed('./TouchCommerceMinimize/TouchCommerceMinimize.png',419,0,16,16)" */
		/*  @Embed('([^\\']*)',([^,]\*),([^,]*),([^,]*),([^,]*))" */


		// haxe.Log.trace("source is: " + s,{ fileName : "SkinLoader.hx", lineNumber : 179, className : "com.inq.ui.SkinLoader", methodName : "unembed"});
		if(StringTools.startsWith(s,"@Embed(")) {
			if(this.getImageMap() != null) try {
				/** @type {?string} */
				var newEmbed = this.getImageMap()[s];
				if (newEmbed != null) {
					s = newEmbed;
				}
			} catch( e ) {
				haxe.Log.trace("map error " + s + ":" + Std.string(e),{ fileName : "SkinLoader.hx", lineNumber : 188, className : "com.inq.ui.SkinLoader", methodName : "unembed"});
			}
			if(embedRegexp.match(s)) {
				// haxe.Log.trace("matched",{ fileName : "SkinLoader.hx", lineNumber : 201, className : "com.inq.ui.SkinLoader", methodName : "unembed"});

				s = embedRegexp.matched(1);
				if(con != null) {
					/** @type {string} */
					var l = embedRegexp.matched(2);
					/** @type {string} */
					var t = embedRegexp.matched(3);
					/** @type {string} */
					var w = embedRegexp.matched(4);
					/** @type {string} */
					var h = embedRegexp.matched(5);

					con.initStyle("sprite-height",h);
					con.initStyle("sprite-width",w);
					con.initStyle("sprite-left",l);
					con.initStyle("sprite-top",t);
					con.isSprite = true;
				}
				bEmbeded = true;
			} else {
				// haxe.Log.trace("unmatched: " + s,{ fileName : "SkinLoader.hx", lineNumber : 208, className : "com.inq.ui.SkinLoader", methodName : "unembed"});
				s = HxOverrides.substr(s,7,s.length - 8);
				bEmbeded = true;
			}
		}
		if(s.charAt(0) == "'") {
			// haxe.Log.trace("remove quote",{ fileName : "SkinLoader.hx", lineNumber : 215, className : "com.inq.ui.SkinLoader", methodName : "unembed"});
			s = HxOverrides.substr(s,1,s.length - 2);
		}
	    //ci-gui
		if (com.inq.flash.client.control.FlashPeer.getIsSkinLocal()) {
		    var skinPath = com.inq.flash.client.control.FlashPeer.getSkinPath();
		    s = (bEmbeded ? skinPath + "/" + s : s).split("/./").join("/");
            if (s.length > 0) {
                //to handle case when different pictures with same name are uploaded
                s = s + "?rand=" + Math.random()
            }
		}
		else {
		    s = (bEmbeded ? com.inq.ui.SkinLoader.getSkinPath() + "/" + s : s).split("/./").join("/");
		}
		return s;
	} catch( e ) {
		throw new String("Could not parse embed: " + source);
	}
};


/**
 * getImageMap - the imageMap maps the standard images defined in the MXML to a master single image
 * If we do not support "canvas" and the method "getContext" then we cannot map the image and we return null.
 * If there is no map, we return null.
 *
 * $type TFun([],TDynamic(null))
 * private function getImageMap():Dynamic
 * @private
 * @this com.inq.ui.SkinLoader
 * @return {null} -
 */
com.inq.ui.SkinLoader.prototype.getImageMap = function() {
	if(com.inq.ui.SkinLoader.spriteMap != null) return com.inq.ui.SkinLoader.spriteMap;
	/** @type {HTMLElement} */
	var tmpCanvas = window.document.createElement("CANVAS");
	/** @type {Object}*/
	var tmpMap = com.inq.utils.Util.getConfig("html5map", null);
	if (tmpCanvas != null) {
		if (tmpCanvas['getContext'] && null != tmpMap) {
			com.inq.ui.SkinLoader.spriteMap = tmpMap;
		} else {
			com.inq.ui.SkinLoader.spriteMap = null;
		}
	}
	return com.inq.ui.SkinLoader.spriteMap;
};

/**
 * executeCode
 *
 * private function executeCode():Void
 * @private
 * @this com.inq.ui.SkinLoader
 * @return {void}
 *
 */
com.inq.ui.SkinLoader.prototype.executeCode = function() {
	try {
		/** @type {Function} */
		var onInit = com.inq.utils.Util.getConfig("onInit", null);
		if (typeof onInit == "function") {
			setTimeout(function() {
				onInit();
			}, 0);
		}
	} catch (e) {
		haxe.Log.trace("Could not run SkinLoader.executeCode. ERROR: " + e , { fileName: "SkinLoader.js", methodName: "executeCode" });
	}
};


/**
 * _successSkinLoad
 *
 * private function _successSkinLoad(e:Event)
 * @private
 * @this com.inq.ui.SkinLoader
 * @param {com.inq.events.Event}  e
 * @return {void}
 */
com.inq.ui.SkinLoader.prototype._successSkinLoad = function(e) {
	if (e.target.responseStatus == 200 || e.target.responseStatus == 304) {
		this._addLoadedSkinToCollection();
		this._draw(this._loaderSkin.data);
		this.dispatchEvent(e);
        //fire a custom event after the skin is loaded
		com.inq.flash.client.chatskins.SkinControl.fireCustomEvent("SkinLoaded");
	}
};

/**
 * drawSkin
 *
 * public function drawSkin(skinPath:String)
 * @public
 * @this com.inq.ui.SkinLoader
 * @param {string}  skinPath
 * @return {void}
 */
com.inq.ui.SkinLoader.prototype.drawSkin = function(skinPath) {
	skinPath = com.inq.ui.SkinLoader.prepareSkinPath(skinPath);

	haxe.Log.trace("drawSkin: " + skinPath, { fileName: "SkinLoader.js", lineNumber: 1247, className: "com.inq.ui.SkinLoader", methodName: "drawSkin" });
	/** @type {object} */
	var obj = com.inq.ui.SkinLoader.skinCollection[skinPath];
	if (null == obj) {
		this._loaderSkin = new com.inq.net.URLLoader();
		this._requestSkin = new com.inq.net.URLRequest(skinPath);
		this._loaderSkin.addEventListener(com.inq.events.Event.COMPLETE, $bind(this, this._successSkinLoad));
		this._loaderSkin.load(this._requestSkin);
	} else {
		haxe.Log.trace("drawSkin: get path from store", { fileName: "SkinLoader.js", lineNumber: 1264, className: "com.inq.ui.SkinLoader", methodName: "drawSkin" });
		this._draw(obj.mxml);
		com.inq.ui.SkinLoader.currentSkin = obj;
		/** @type {com.inq.events.Event} */
		var e = new com.inq.events.Event(com.inq.events.Event.COMPLETE);
		this.dispatchEvent(e);
	}
};

/**
 * drawSkinLocal
 * This code is for the ci gui only
 * which loads the skin locally and before executing application main,
 * also mocks some sample text
 *
 * @public
 * @this com.inq.ui.SkinLoader
 */
com.inq.ui.SkinLoader.prototype.drawSkinLocal = function() {
	/** @type {?string} */
	var mxmlData = com.inq.flash.client.control.FlashPeer.getSkinMXML();
	this._draw(mxmlData);
	/** @type {com.inq.events.Event} */
	var e = new com.inq.events.Event(com.inq.events.Event.COMPLETE);
	this.dispatchEvent(e);

	if (com.inq.flash.client.control.FlashPeer.getIsBuilder()) {
		var agentName = com.inq.flash.client.control.FlashVars.getAgentName();
		com.inq.flash.client.control.ApplicationController.prototype.appendReceivedText("Hello how can I help you?", agentName, 1);
		com.inq.flash.client.control.ApplicationController.prototype.appendSentText("I need help with my account.", 2);
		com.inq.flash.client.control.ApplicationController.prototype.appendReceivedText("Sure I can help you with that.", agentName, 3);
		com.inq.flash.client.control.ApplicationController.prototype.appendReceivedText("This is a system message: Your chat has been disconnected.", "system", 4);
		var systemMessage = com.inq.utils.Util.getConfig("sAgentIsTyping", "Agent is typing...");
		com.inq.flash.client.control.ApplicationController.prototype.appendReceivedText(systemMessage, "", 5);
	}
};

/**
 * Adds the loaded skin to the skins collection.
 * @private
 * @this com.inq.ui.SkinLoader
 * @return {void}
 */
com.inq.ui.SkinLoader.prototype._addLoadedSkinToCollection = function() {
	/** @type {string} */
	var path = this._requestSkin.url;
	com.inq.ui.SkinLoader.skinCollection[path] = { mxml : this._loaderSkin.data, path : path};
	com.inq.ui.SkinLoader.currentSkin = com.inq.ui.SkinLoader.skinCollection[path];
};

/**
 * cleanUp
 *
 * @return {void}
 */

com.inq.ui.SkinLoader.prototype.cleanUp = function () {
	com.inq.ui.SkinLoader.contextArray = [];
	com.inq.ui.SkinLoader.skinCollection = {};
	com.inq.ui.SkinLoader.currentSkin = null;
};
/** @private @type {com.inq.net.URLRequest} */
com.inq.ui.SkinLoader.prototype._requestSkin = null;
/** @private @type {com.inq.net.URLLoader} */
com.inq.ui.SkinLoader.prototype._loaderSkin = null;
/** @type {com.inq.ui.SkinLoader} */
com.inq.ui.SkinLoader.prototype.__class__ = com.inq.ui.SkinLoader;
/** @type {string} */
com.inq.ui.SkinLoader.OVERALL_CONTAINER_ID = "Skin";
/** @type {string} */
com.inq.ui.SkinLoader.LOADER_CONTAINER_ID = "tc-chat-loader";
/** @private @type {string} */
com.inq.ui.SkinLoader._skinpath = com.inq.ui.SkinLoader._getSkinPath();
/** @type {?{mxml: string, path: string}} */
com.inq.ui.SkinLoader.currentSkin = null;
/** @private @type {object} */
com.inq.ui.SkinLoader.skinCollection = {};

/** @private @type {Array} */
com.inq.ui.SkinLoader.contextArray = [];

/** @private @type {number} */
com.inq.ui.SkinLoader.imageCount = 0;

/** @type {null} */
com.inq.ui.SkinLoader.spriteMap = null;

/** @type {boolean} */
com.inq.ui.SkinLoader.newSkinLoaded = false;
